export default class UserService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/users', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/users/' + id, params)
	}

	getLoggedUserData() {
		return this.apiService.callGet('me/users/loggedUser')
	}

	createEntity(params) {
		return this.apiService.callPost('me/users', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/users/' + id, params)
	}

	uploadEntityImage(id, file) {
		return this.apiService.callPost('me/users/' + id + '/user_image', file)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/users/' + id, params)
	}

	deleteImage(id) {
		return this.apiService.callDelete('me/users/' + id + '/image')
	}
}



// WEBPACK FOOTER //
// ./src/service/UserService.js